module.exports = __webpack_public_path__ + "static/media/lateral-nonflexion.f01a74c5.png";